// flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import styled from 'styled-components'
import media from '../../styles/media'
import {
  fetchFavoriteProperty,
  resetFavoriteProperties
} from '../../actions/user'
import PropertyCard from '../../components/PropertyCard'
import Pager from '../../components/Pager'

const Favorite = styled.div`
  ${media.lgUp} {
    width: 48%;
  }
`

type Props = {
  fetchFavoriteProperty: Function, // eslint-disable-line react/no-unused-prop-types
  resetFavoriteProperties: Function,
  favoriteProperties: Array<Object>,
  favorites: Array<{ mls_id: number }>
}

type State = {
  limit: number,
  offset: number
}

class UserFavorites extends Component {
  constructor(props: Props) {
    super(props)
    this.state = {
      limit: 4,
      offset: 0
    }
  }

  state: State

  componentDidMount() {
    if (this.props.favorites.length) {
      this.fetchProperties(this.props)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.favorites.length && !this.props.favorites.length) {
      this.fetchProperties(nextProps)
    }
  }

  props: Props

  fetchProperties = (props: Props) => {
    const favoriteMlsIds = props.favorites
      .slice(this.state.offset, this.state.offset + this.state.limit)
      .map((favorite) => favorite.mls_id)
    favoriteMlsIds.map((mlsId) => props.fetchFavoriteProperty(mlsId))
  }

  handlePrevPageClick = () => {
    this.props.resetFavoriteProperties().then(() => {
      const offset = this.state.offset - this.state.limit
      this.setState({ offset }, this.fetchProperties(this.props))
    })
  }

  handleNextPageClick = () => {
    this.props.resetFavoriteProperties().then(() => {
      const offset = this.state.offset + this.state.limit
      this.setState({ offset }, this.fetchProperties(this.props))
    })
  }

  render() {
    return (
      <div>
        <Helmet title="Favorites" />
        <Pager
          limit={this.state.limit}
          offset={this.state.offset}
          style={{ margin: '2rem 0' }}
          results={this.props.favorites.length}
          onPrevPageClick={this.handlePrevPageClick}
          onNextPageClick={this.handleNextPageClick}
        />
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
          }}
        >
          {this.props.favoriteProperties.map((property) => (
            <Favorite key={property.mlsId}>
              <PropertyCard property={property} />
            </Favorite>
          ))}
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    favorites: state.user.favorites,
    favoriteProperties: state.user.favoriteProperties
  }),
  {
    fetchFavoriteProperty,
    resetFavoriteProperties
  }
)(UserFavorites)



// WEBPACK FOOTER //
// ./src/views/UserFavorites/index.js